import type { ReactNode } from 'react';

/**
 * Shared shell for "gate" screens — a single icon badge, title, description
 * and one action row, centered. Used for every precondition that blocks a
 * page/modal's normal content (no wallet, no linked social, no bot
 * connection yet) so they all read as the same family of popup.
 */
export interface GateShellProps {
  icon: ReactNode;
  title: string;
  titleId?: string;
  description: ReactNode;
  children: ReactNode;
}

export function GateShell({ icon, title, titleId, description, children }: GateShellProps) {
  return (
    <div className="space-y-5 px-6 py-10 text-center">
      <div className="mx-auto grid h-14 w-14 place-items-center rounded-2xl bg-water-50 ring-1 ring-inset ring-[#CFE3F3] text-water-700">
        {icon}
      </div>
      <div className="space-y-2">
        <h2
          id={titleId}
          className="font-display text-2xl font-bold tracking-tightish text-ink-950"
        >
          {title}
        </h2>
        <p className="mx-auto max-w-md text-sm leading-relaxed text-slate2-600">
          {description}
        </p>
      </div>
      <div className="flex justify-center">{children}</div>
    </div>
  );
}

export default GateShell;
